const DB_NAME = 'maverick-video-uploads';
const STORE = 'sessions';

const openDb = () =>
  new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1);
    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: 'questionId' });
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });

const withStore = async (mode, fn) => {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, mode);
    const store = tx.objectStore(STORE);
    const result = fn(store);
    tx.oncomplete = () => resolve(result);
    tx.onerror = () => reject(tx.error);
    tx.onabort = () => reject(tx.error);
  });
};

export const getVideoUploadSession = async questionId => {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, 'readonly');
    const request = tx.objectStore(STORE).get(String(questionId));
    request.onsuccess = () => resolve(request.result || null);
    request.onerror = () => reject(request.error);
  });
};

export const listVideoUploadSessions = async () => {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, 'readonly');
    const request = tx.objectStore(STORE).getAll();
    request.onsuccess = () => resolve(request.result || []);
    request.onerror = () => reject(request.error);
  });
};

export const saveVideoUploadSession = async session => {
  const questionId = String(session.questionId);
  const existing = session.replace ? null : await getVideoUploadSession(questionId);
  const next = {
    ...(existing || {}),
    ...session,
    questionId,
    blob: Object.prototype.hasOwnProperty.call(session, 'blob')
      ? session.blob
      : existing?.blob || null,
    updatedAt: Date.now(),
  };
  delete next.replace;
  await withStore('readwrite', store => {
    store.put(next);
  });
  return next;
};

export const clearVideoUploadSession = async questionId => {
  await withStore('readwrite', store => {
    store.delete(String(questionId));
  });
};

export const clearAllVideoUploadSessions = async () => {
  await withStore('readwrite', store => {
    store.clear();
  });
};
